// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';

const styles = css`
  .checkmark {
    top: -12px;
    right: -11px;
  }
  .address-carousel-edit-btn {
    float: right;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.button.size}px;
    line-height: 1.71;
    letter-spacing: 0.2px;
    color: ${(props) => props.theme.colors.BUTTON.BLACK.NORMAL};
    text-decoration: underline;
    border: 0;
    text-transform: capitalize;
    position: absolute;
    top: 6px;
    right: 6px;
  }

  .address-carousel-header-container {
    margin-right: 0;
  }

  .address-carousel-parent-cta {
    position: relative;
    top: 25%;
    text-align: right;
  }

  .address-carousel-card {
    display: flex;
    margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG} 0 0;
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.colors.PRIMARY.GRAY};
    background-color: ${(props) => props.theme.colors.PRIMARY.WHITE};
    min-width: 212px;
    height: 138px;
    cursor: pointer;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 2px;

    &:focus-visible {
      outline: 0;
      box-shadow: 0 0 0 2px ${(props) => props.theme.colorPalette.pink[600]};
    }
  }

  .add-newAddress-card {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    margin: 0;
  }

  .address-carousel-card.selected {
    border: 3px solid ${(props) => props.theme.colorPalette.blue[500]};
    cursor: auto;
    box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.12);
  }

  .address-carousel-card-content {
    display: flex;
    align-items: center;
    width: 100%;
    height: 140px;
    position: relative;
    justify-content: center;
  }

  .address-carousel-cta {
    display: block;
  }

  .address-carousel-field {
    margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XXS} 0 0;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    line-height: 1.43;
    letter-spacing: 0.21px;
    color: ${(props) => props.theme.colors.PRIMARY.BLACK};
    white-space: nowrap;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 20px;
    text-align: left;
  }
  .add-new-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  .add-new-img {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    background: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
    border-radius: 50%;
  }

  .slick-prev {
    left: 0px;

    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 144px;
      width: 15px;
      background-color: ${(props) => props.theme.colorPalette.white};
    }
  }

  .slick-next {
    right: 0px;

    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 144px;
      width: 15px;
      background-color: ${(props) => props.theme.colorPalette.white};
    }
  }

  .slick-disabled {
    display: none !important;
  }
`;

export const AddressCarouselCard = styled(BodyCopy)`
  margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG} 0 0;
  border-radius: 6px;
  border: 1px solid ${(props) => props.theme.colors.PRIMARY.GRAY};
  background-color: ${(props) => props.theme.colors.PRIMARY.WHITE};
  min-width: 212px;
  min-height: 138px;
  max-height: 170px;
  cursor: pointer;
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  &:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 2px ${(props) => props.theme.colorPalette.pink[600]};
  }
  ${(props) =>
    props.isSelected
      ? `
      border: 3px solid ${props.theme.colorPalette.blue[500]};
      cursor: auto;
      box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.12);
  `
      : ``}
`;

export const AddressHeaderText = styled(BodyCopy)`
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  font-size: ${(props) => props.theme.typography.fontSizes.fs15};
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  display: inline-block;
  margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XL_1};
`;

export const MakeDefaultWrapper = styled.div`
  display: inline-block;
  margin-left: 40px;
`;

export const TickMarkBlock = styled.div`
  display: inline !important;
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: ${(props) => props.theme.colorPalette.green[500]};
  border-radius: 10px;
  justify-content: center;
  align-items: center;

  img {
    display: inline-block;
    padding-left: 4px;
    padding-right: 4px;
    height: 8px;
    width: 8px;
    vertical-align: top;
    padding-top: 4px;
  }
`;

export const MakeDefaultButton = styled(Button)`
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  line-height: 1.71;
  letter-spacing: 0.2px;
  color: ${(props) => props.theme.colors.BUTTON.BLACK.NORMAL};
  text-decoration: underline;
  border: 0;
  text-transform: capitalize;
  margin-left: 16px;
  top: -5px;
  padding-right: 0;
  display: inline-block;
  ${(props) =>
    props.isDefault
      ? `
  width: 55px;
  cursor: default;
  font-weight: ${props.theme.fonts.fontWeight.bold};
  text-decoration:none;
  `
      : `width: 90px;`}
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    top: -3px;
  }
`;

export const EditButton = styled(Button)`
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-size: ${(props) => props.theme.fonts.fontSize.button.size}px;
  line-height: 1.71;
  letter-spacing: 0.2px;
  color: ${(props) => props.theme.colors.BUTTON.BLACK.NORMAL};
  text-decoration: underline;
  border: 0;
  text-transform: capitalize;
  padding-left: 0;
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
`;
export default styles;
